
import { MessageSquare } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-50 py-12 px-6 md:px-12 border-t">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold text-xl mb-4 bg-gradient-to-r from-seo-primary to-seo-secondary bg-clip-text text-transparent">
              LocalUp - SEO Local
            </h3>
            <p className="text-gray-600 mb-4">
              Ajudamos empresas locais a serem encontradas online, aumentando sua visibilidade e atraindo mais clientes.
            </p>
            <div 
              onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
              className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md cursor-pointer"
            >
              <MessageSquare className="w-4 h-4" /> Fale no WhatsApp
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Serviços</h4>
            <ul className="space-y-2">
              <li><a href="/servicos/seo-local" className="text-gray-600 hover:text-seo-primary">SEO Local</a></li>
              <li><a href="/servicos/otimizacao-sites" className="text-gray-600 hover:text-seo-primary">Otimização de Sites</a></li>
              <li><a href="/servicos/google-meu-negocio" className="text-gray-600 hover:text-seo-primary">Google Meu Negócio</a></li>
              <li><a href="/servicos/avaliacoes-online" className="text-gray-600 hover:text-seo-primary">Avaliações Online</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Contato</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-seo-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                contato@localup.com.br
              </li>
              <li className="flex items-center text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-seo-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                +55 11 5197-4403
              </li>
              <li className="flex items-center text-gray-600 hover:text-green-500 cursor-pointer" onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}>
                <MessageSquare className="h-5 w-5 mr-2 text-green-500" />
                WhatsApp
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-200 text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} LocalUp SEO Local. Todos os direitos reservados.
          <p className="mt-2">localup.com.br</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
